module.exports = __webpack_public_path__ + "08b4ed6116a9bfbe3f703ad752903701.svg";